import { Round } from "@pdfking/math"
import type { RGBColor } from "@pdfking/math"

// The id of the plot's tint filter for a color (see MediaDefs): one per color,
// shared by every media drawn in it
export const TintFilterID = ({ alpha, blue, green, red }: RGBColor): string =>
  `tint-${[red, green, blue, alpha].map(v => Round(v * 1000)).join("-")}`
